function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-v-b1088674": "",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  "data-v-b1088674": "",
  id: "nav/light/base",
  transform: "translate(-15.000000, -17.000000)",
  fill: "#ff4876"
}, /*#__PURE__*/React.createElement("polyline", {
  "data-v-b1088674": "",
  id: "Fill-6",
  points: "30.9999025 17 15 32.9999025 30.9999025 32.9999025 30.9999025 49 47 32.9999025 47 17 30.9999025 17"
})));

const SvgPendo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "data-v-b1088674": "",
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32",
  role: "img",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPendo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pendo.16f06851.svg";
export { ForwardRef as ReactComponent };